import { customAlphabet } from 'nanoid';

const getCustomHash =  customAlphabet('ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789', 6);

export { getCustomHash }